let template=`
{{#if expandable}}
    <nav class="open-close" data-id="{{id}}" data-target="#">
        <span class="expando fa fa-caret-right" />
        <span class="retracto fa fa-caret-down" />
    </nav>
{{/if}}
<i class="fa {{icon}}" data-id="devicegroups"></i>
<main>
    {{#if relationship_type}}
        <div class="relationship-type info-field">{{relationship_type}}</div>
    {{/if}}
    <div class="name-field">
        <a href="/ide/devicegroup/{{id}}" class="name btn btn-link">{{name}}</a>
    </div>
    <div class="info-field">
        <div class="description info"><strong>Description:</strong> {{#if description}}{{description}}{{else}}<em>no description</em>{{/if}}</div>
    </div>
    <ul class="device-group-region">
        <li class="devicegroup-info">{{! device group region }}</li>
        <li class="devicecount-info">{{! device count region }}</li>
        <li class="deployment-info">{{! deployment region }}</li>
        <li class="last-deployed-info">{{! last deployment date deployment region }}</li>
    </ul>
    {{#if show_actions}}
    <nav class="pills">
        <label>Actions</label>
        <ul class="nav nav-pills">
            {{#if show_draft}}
                <li><button class="btn btn-link action draft-code">Code</button></li>
            {{/if}}
            {{#if show_deploy}}
                <li><button class="btn btn-link action deploy">Deploy</button></li>
            {{/if}}
            {{#if show_code_history}}
                <li><button class="btn btn-link action code-history">Deployments</button></li>
            {{/if}}
            {{#if show_devices}}
                <li><button class="btn btn-link action devices">Devices</button></li>
            {{/if}}
            {{#if show_blessed_devices}}
                <li><button class="btn btn-link action blessed-devices">Test Production Devices</button></li>
            {{/if}}
            {{#if show_update}}
                <li><button class="btn btn-link action update">Update Name</button></li>
            {{/if}}
            {{#if show_settings}}
                <li><button class="btn btn-link action settings">Settings</button></li>
            {{/if}}
            {{#if show_delete}}
                <li><button class="btn btn-link action delete">Delete</button></li>
            {{/if}}
            {{#if show_go_live}}
                <li><span class="go-live-region action"></span></li>
            {{/if}}
            {{#if show_clone}}
                <li><button class="clone btn btn-link action">clone</span></li>
            {{/if}}
        </ul>
    </nav>
    <nav class="actions">
        <div class="dropdown">
            <div class="fa fa-ellipsis-v action-menu" id="dLabel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                <ul class="dropdown-menu pull-right" aria-labelledby="dLabel">
                {{#if show_draft}}
                <li><button class="btn btn-link action draft-code">Code</button></li>
                {{/if}}
                {{#if show_deploy}}
                    <li><button class="btn btn-link action deploy">Deploy</button></li>
                {{/if}}
                {{#if show_code_history}}
                    <li><button class="btn btn-link action code-history">Deployments</button></li>
                {{/if}}
                {{#if show_blessed_devices}}
                    <li><button class="btn btn-link action blessed-devices">Test Production Devices</button></li>
                {{/if}}
                {{#if show_devices}}
                    <li><button class="btn btn-link action devices">Devices</button></li>
                {{/if}}
                {{#if show_update}}
                    <li><button class="btn btn-link action update">Update Name</button></li>
                {{/if}}
                {{#if show_settings}}
                    <li><button class="btn btn-link action settings">Settings</button></li>
                {{/if}}
                {{#if show_delete}}
                    <li><button class="btn btn-link action delete">Delete</button></li>
                {{/if}}
                {{#if show_go_live}}
                    <li><span class="go-live-region action"></span></li>
                {{/if}}
            </ul>
        </div>
    </nav>
    {{/if}}
    </details>
</main>

<div class="relationships-region">{{! relationships region }}</div>`;

export default template;
